import { Icon } from "@blueprintjs/core";

import { BLUE_TEXT_COLOR, INNER_BORDER_COLOR, RED } from "@/css/constants";

const STATUS_COLOR_MAP: Record<string, string> = {
  complete: "#27AE60B2",
  inProgress: BLUE_TEXT_COLOR,
  notStarted: INNER_BORDER_COLOR,
  cancelled: RED,
};

interface StatusIndicatorProps {
  status?: string;
  size?: number;
}

export function StatusIndicator({ status, size }: StatusIndicatorProps) {
  const color = status ? STATUS_COLOR_MAP[status] : INNER_BORDER_COLOR;
  return <Icon icon="full-circle" size={size || 16} color={color} />;
}
